import React, { useEffect, useState } from "react"
import { Card, Button, Form, Row, Col, Spinner, Alert } from "react-bootstrap"
import { useNavigate, useParams } from "react-router-dom"
import Layout from "../../../layout/default"
import Block from "../../../components/Block/Block"
import { Icon } from "../../../components"
import service from "../services/billingCycleService"

const emptyRec = {
  code: "",
  name: "",
  months: 1,
  discount_percent: 0,
  active: true,
}

const BillingCycleEdit = () => {
  const { id: rawId } = useParams()
  const isNew = rawId === 'new' || !rawId
  const billingCycleId = !isNew ? rawId : null
  const navigate = useNavigate()

  const [item, setItem] = useState(emptyRec)
  const [loading, setLoading] = useState(Boolean(billingCycleId))
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!billingCycleId) {
      setLoading(false)
      return
    }
    let mounted = true
    ;(async () => {
      setLoading(true)
      setError(null)
      try {
        const data = await service.get(billingCycleId)
        if (mounted) setItem(data)
      } catch (err) {
        console.error('Error fetching billing cycle', err)
        if (mounted) setError('No se pudo cargar el ciclo.')
      } finally {
        if (mounted) setLoading(false)
      }
    })()
    return () => {
      mounted = false
    }
  }, [billingCycleId])

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target
    setItem((prev) => ({ ...prev, [name]: type === 'checkbox' ? checked : value }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setSaving(true)
    setError(null)
    try {
      if (isNew) {
        await service.create(item)
      } else if (billingCycleId) {
        await service.update(billingCycleId, item)
      }
      navigate('/billing-cycle')
    } catch (err) {
      console.error('Error saving billing cycle', err)
      setError('No se pudo guardar el ciclo.')
    } finally {
      setSaving(false)
    }
  }

  return (
    <Layout
      title={isNew ? 'Nuevo Ciclo' : `Editar Ciclo #${billingCycleId}`}
      content="container"
      loading={loading || saving}
    >
      <Block.Head>
        <Block.HeadBetween>
          <Block.HeadContent>
            <Block.Title tag="h2">
              {isNew ? 'Nuevo Ciclo de Facturación' : `Editar Ciclo #${billingCycleId}`}
            </Block.Title>
          </Block.HeadContent>
        </Block.HeadBetween>
      </Block.Head>

      <Block>
        <Card body>
          {error && <Alert variant="danger">{error}</Alert>}
          {loading ? (
            <Spinner animation="border" />
          ) : (
            <Form onSubmit={handleSubmit}>
              <Row className="g-3">
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Código</Form.Label>
                    <Form.Control
                      name="code"
                      value={item.code}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={8}>
                  <Form.Group>
                    <Form.Label>Nombre</Form.Label>
                    <Form.Control
                      name="name"
                      value={item.name}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Meses</Form.Label>
                    <Form.Control
                      type="number"
                      name="months"
                      min="1"
                      value={item.months}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Descuento %</Form.Label>
                    <Form.Control
                      type="number"
                      name="discount_percent"
                      step="0.01"
                      value={item.discount_percent}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={4} className="d-flex align-items-end">
                  <Form.Check
                    type="checkbox"
                    label="Activo"
                    name="active"
                    checked={item.active}
                    onChange={handleChange}
                  />
                </Col>
                <Col xs={12} className="text-end">
                  <Button variant="primary" type="submit" disabled={saving}>
                    {saving ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          className="me-2"
                        />
                        Guardando…
                      </>
                    ) : (
                      <>
                        <Icon name="save" />
                        <span> Guardar</span>
                      </>
                    )}
                  </Button>
                </Col>
              </Row>
            </Form>
          )}
        </Card>
      </Block>
    </Layout>
  )
}

export default BillingCycleEdit
